export default __webpack_public_path__ + "static/media/epostal2.8d1daaf2.jpg";